import { render, staticRenderFns } from "./clientBalance.vue?vue&type=template&id=7c4aac46&"
import script from "./clientBalance.vue?vue&type=script&lang=js&"
export * from "./clientBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports